import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import FloatingVue from 'floating-vue'
import i18n from './i18n'
import App from './App'
import Dashboard from './components/views/Dashboard'
import TasksView from './components/views/TasksView'
import Calendar from './components/views/Calendar'
import Reports from './components/views/Reports'
import Projects from './components/views/Projects'
import SignUp from './components/views/SignUp'
import SignIn from './components/views/SignIn'
import SignOut from './components/views/SignOut'
import { plugin as Slicksort } from 'vue-slicksort'
import store from './store'
import Settings from './components/views/Settings.vue'
import ResetPassword from './components/views/ResetPassword.vue'
import ResetPasswordChange from "@/components/views/ResetPasswordChange.vue"
import ConfirmRegistration from "@/components/views/ConfirmRegistration.vue"
import ConfirmRegistrationCheckEmail from "@/components/views/ConfirmRegistrationCheckEmail.vue";
import LandingPage from "@/components/landingpage/components/LandingPage.vue";


const routeGuard = (to, from) => {
  if(to.meta.authRequired) {
    if(store.getters.user) {
      return true
    } else {
      if(from.meta.authRequired || Object.keys(from.meta).length === 0) return { name: 'signIn' }
      return false
    }
  }

  if(to.meta.redirectIfAuthorized) {
    if(store.getters.user) {
      if(from.meta.redirectIfAuthorized || Object.keys(from.meta).length === 0) return { name: 'home' }
      return false
    } else {
      return true
    }
  }
}

const routes = [
  {
    name: 'landingpage',
    path: '/',
    component: LandingPage,
    meta: { disableOuterBorder: true }
  },
  {
    name: 'features',
    path: '/features',
    component: LandingPage,
    meta: { disableOuterBorder: true }
  },
  {
    name: 'how',
    path: '/how',
    component: LandingPage,
    meta: { disableOuterBorder: true }
  },
  {
    name: 'contact',
    path: '/contact',
    component: LandingPage,
    meta: { disableOuterBorder: true }
  },
  {
    name: 'privacy',
    path: '/privacy',
    component: LandingPage,
    meta: { disableOuterBorder: true }
  },
  {
    name: 'terms',
    path: '/terms',
    component: LandingPage,
    meta: { disableOuterBorder: true }
  },
  {
    name: 'home',
    path: '/home',
    component: Dashboard,
    meta: {
      authRequired: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'tasks',
    path: '/tasks/:projectId?/:boardId?',
    component: TasksView,
    meta: {
      authRequired: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'calendar',
    path: '/calendar',
    component: Calendar,
    meta: {
      authRequired: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'reports',
    path: '/reports',
    component: Reports,
    meta: {
      authRequired: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'projects',
    path: '/projects',
    component: Projects,
    meta: {
      authRequired: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'signUp',
    path: '/signup',
    component: SignUp,
    meta: {
      redirectIfAuthorized: true,
      hideSideBar: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'signIn',
    path: '/signin',
    component: SignIn,
    meta: {
      redirectIfAuthorized: true,
      hideSideBar: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'signOut',
    path: '/signout',
    component: SignOut,
    meta: {
      authRequired: true,
      hideSideBar: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'resetpassword',
    path: '/resetpassword',
    component: ResetPassword,
    meta: {
      redirectIfAuthorized: true,
      hideSideBar: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'resetpasswordchange',
    path: '/resetpassword/:token',
    component: ResetPasswordChange,
    meta: {
      redirectIfAuthorized: true,
      hideSideBar: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'confirmregistration',
    path: '/confirmregistration/:token',
    component: ConfirmRegistration,
    meta: {
      redirectIfAuthorized: true,
      hideSideBar: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'confirmregistrationcheckemail',
    path: '/confirmregistrationcheckemail',
    component: ConfirmRegistrationCheckEmail,
    meta: {
      redirectIfAuthorized: true,
      hideSideBar: true
    },
    beforeEnter: routeGuard
  },
  {
    name: 'settings',
    path: '/settings/:sessionId?',
    component: Settings,
    meta: {
      authRequired: true
    },
    beforeEnter: routeGuard
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

createApp(App)
  .use(FloatingVue)
  .use(Slicksort)
  .use(store)
  .use(i18n)
  .use(router).mount('#app')

